import { render, staticRenderFns } from "./ChangeMobileNumber.vue?vue&type=template&id=4e836740"
import script from "./ChangeMobileNumber.vue?vue&type=script&lang=js"
export * from "./ChangeMobileNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports